import { jsx as n } from "react/jsx-runtime";
import e, { useState as m, useCallback as L } from "react";
import { LocalizationProvider as p } from "./help-center-knowledge-anatomies4.js";
import { getLocalizationResource as z } from "./help-center-knowledge-anatomies8.js";
const a = e.createContext(null), C = () => {
  const o = e.useContext(a);
  if (!o)
    throw new Error("useLocalization must be used within an AppLocalizationProvider");
  return o;
}, P = ({ children: o, initialLocale: c = "en-us" }) => {
  const [t, i] = m(c), r = e.useMemo(() => z(t), [t]), l = L((u) => {
    i(u);
  }, []), s = {
    currentLocale: t,
    setLocale: l,
    localizationData: r
  };
  return /* @__PURE__ */ n(a.Provider, { value: s, children: /* @__PURE__ */ n(p, { locale: t, localizationData: r, children: o }) });
};
export {
  P as AppLocalizationProvider,
  a as LocalizationContext,
  C as useLocalization
};
//# sourceMappingURL=help-center-knowledge-anatomies5.js.map
